// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__PmF5g","right":"styles_right__1WGFS"};